const completions = new Map();

async function request(user, path, { method = "GET", body } = {}) {
  const token = await user?.getIdToken?.();
  if (!token) throw new Error("Sign in to Kre8 to use Instagram testing.");
  const base = String(process.env.REACT_APP_ENDPOINT || "").replace(/\/$/, "");
  const response = await fetch(`${base}/api/instagram/test/${path}`, {
    method, headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(result.error || "Instagram testing could not be loaded.");
  return result;
}

export const getInstagramTestStatus = (user) => request(user, "status");
export const startInstagramTest = (user) => request(user, "start", { method: "POST" });
export const disconnectInstagramTest = (user) => request(user, "connection", { method: "DELETE" });
export const getInstagramTestReels = (user, { after, insights = false } = {}) => {
  const query = new URLSearchParams({ insights: insights ? "1" : "0", ...(after ? { after } : {}) });
  return request(user, `reels?${query}`);
};
export function completeInstagramTest(user, handoff) {
  const key = `${user?.uid}:${handoff}`;
  if (!completions.has(key)) {
    if (completions.size >= 10) completions.delete(completions.keys().next().value);
    completions.set(key, request(user, "complete", { method: "POST", body: { handoff } }));
  }
  return completions.get(key);
}
